import { useCallback, useMemo } from 'react'

import { indexes } from '@mab-common/utils'

import Checkbox from '~/components/atoms/Checkbox/Checkbox'
import Text, { TextSizes } from '~/components/atoms/Text/Text'
import type { TSearchAnalystEventProps } from '~/services/elastic/analyst'
import useSearchAnalyst from '~/services/elastic/analyst'

import type { formatsType } from '../ArtworksList/ArtworksList'

import styles from './Filters.module.css'
import EsIndexTypes = indexes.EsIndexTypes
import { multiPostHogEventPusher } from '~/utils/analyticsPusher'

interface FilterListProps {
  items?: formatsType
  title?: string
  changeHandler: (index: string) => void
  checkedItems: any
  testID?: string
  searchInsightsEvent?: TSearchAnalystEventProps
  filterType?: string
  testAttr?: string
}

const FilterList = ({
  items,
  title,
  changeHandler,
  checkedItems,
  testID,
  searchInsightsEvent,
  filterType,
  testAttr,
}: FilterListProps) => {
  const { sendSearchInsightsEvent } = useSearchAnalyst()

  const eventFilterType = useMemo(
    () => (filterType === 'genre' ? 'genres' : filterType),
    [filterType]
  )

  const onFilterClick = useCallback(
    async (id: string) => {
      changeHandler(id)

      if (searchInsightsEvent) {
        sendSearchInsightsEvent(searchInsightsEvent.method, {
          indexType: EsIndexTypes.ARTWORKS,
          eventName: searchInsightsEvent.name,
          filters: [`${eventFilterType}._id:${id}`],
        })
      }

      await multiPostHogEventPusher([
        {
          eventType: searchInsightsEvent?.name || `${title} filter clicked`,
        },
      ])
    },
    [searchInsightsEvent?.method, searchInsightsEvent?.name, checkedItems]
  )

  return (
    <div className={styles.filterList}>
      {title && (
        <Text
          size={TextSizes.primaryTitleLrg}
          Tag="h4"
          className={styles.filterListTitle}
        >
          {title}
        </Text>
      )}

      {items?.map((item, i) => {
        return (
          <div
            className={styles.checkboxWrap}
            key={`${item.slug}-${i}`}
            data-testid={testID}
            data-insights-filter={item.slug}
          >
            <Checkbox
              label={item.name}
              count={item.count}
              testAttr={testAttr}
              name={item.slug}
              id={item._id}
              value={item.slug}
              onChange={() => {
                onFilterClick(item._id)
              }}
              checked={
                checkedItems.find((match: any) => match.id == item._id)
                  ?.checked || false
              }
              testID={testID && `checkbox-${i}-${testID}`}
            />
          </div>
        )
      })}
    </div>
  )
}

export default FilterList
